module.exports = new __parcel__URL__("pophigh.5b35f8ed.mp3").toString();